import { useEffect, useRef } from 'react';
import useMap from '../../hooks/map/useMap';
import useMapLocation from '../../hooks/map/useMapLocation';

/**
 * @description
 * This hook is responsible for watching for changes to the location and ensuring that
 * they always sync to the map by calling `map.setView()`. If not it becomes possible
 * that the map loads before a state change can be made and it would load with the incorrect
 * center point.
 */
const useSyncLocationToMap = () => {
  const [map] = useMap();
  const { location, locationLoaded } = useMapLocation();
  const mountedRef = useRef(true);

  // Track mounted state
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (!mountedRef.current || !map || !location || !locationLoaded) {
      return;
    }

    // Verify the map is in a valid state with a container before attempting to set view

    const hasValidContainer =
      Object.prototype.hasOwnProperty.call(map, '_container') &&
      map._container &&
      map._container.parentNode;

    if (!hasValidContainer) {
      return;
    }

    try {
      // Additional safety check before setting view
      if (mountedRef.current && map.setView && typeof map.setView === 'function') {
        map.setView(location.center, location.zoom);
      }
    } catch (_error) {
      // Silently handle errors during view setting
    }
  }, [map, location, locationLoaded]);
};

export default useSyncLocationToMap;
